import { render, staticRenderFns } from "./TipBtn.vue?vue&type=template&id=97036cbe&scoped=true&"
import script from "./TipBtn.vue?vue&type=script&lang=js&"
export * from "./TipBtn.vue?vue&type=script&lang=js&"
import style0 from "./TipBtn.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TipBtn.vue?vue&type=style&index=1&id=97036cbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97036cbe",
  null
  
)

export default component.exports